export function checkIsEmoji(emoji: string): boolean {
  // improve
  return emoji.length < 3;
}
